import React from 'react'
import {
  Edit,
  PortraitSelectorDialog as ImageSelectorDialog,
  Replace,
  Upload,
  UserGallery,
} from '@fs/zion-portrait-selector'
import { useTranslation } from 'react-i18next'
import { useMemoryBook } from '../../../../../providers/MemoryBookProvider'

export default function ImagePickerOverlay({
  overlay,
  savedImage,
  onSave,
  onRemove,
  updateImage,
  onUpload,
  selectedImage,
  targetDimensions,
}) {
  const { memoryViewerOverlay } = useMemoryBook()
  const openTo = savedImage ? 'replace' : 'add'
  const [t] = useTranslation()

  return (
    <ImageSelectorDialog {...overlay} openTo={openTo} imageSelectorMode>
      <Edit
        key={`edit-${selectedImage?.url}`}
        alt={t('ImagePickerOverlay.editor.label', 'Adjust Image')}
        image={selectedImage?.url ? { href: selectedImage.url } : undefined}
        onSave={async (e) => {
          await onSave(selectedImage)

          memoryViewerOverlay.handleClick(e)
        }}
        onRemove={onRemove}
        imageSelectorMode
        targetDimensions={targetDimensions}
      />
      <Replace key={`replace-${selectedImage?.url}`}>
        <Upload onUpload={onUpload} />
        <UserGallery onPhotoClick={updateImage} imageSelectorMode />
      </Replace>
    </ImageSelectorDialog>
  )
}
